import React, { useEffect, useState, useContext, useRef } from 'react';
import { Link } from "react-router-dom";
import ProfileContext from '../../../../services/profileContext';
import Layout from '../../../parts/Layout';
import { httpRequest, httpAuthHeaders } from '../../../../services/httpService';
import helpers from '../../../../services/helpers';
import Loader from '../../../parts/Loader';
import CategoryFormModal from '../../../modals/CategoryFormModal';
import initTreeView from '../../../../services/initTreeView';
//import ShipsFormModal from './ShipsFormModal';
import Swal from 'sweetalert2';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import Dropdown from 'react-bootstrap/Dropdown'
import { Toast } from 'primereact/toast';

import {
    FaRegFileExcel,
    FaTimesCircle
} from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
 
export default function BookingList ({viewer = 'admin', menu = 'manage-bookings', page_title = "Manage Bookings"}){
    const {
        account
    } = useContext(ProfileContext);
    const toast = useRef(null);
    const menuRight = useRef(null);
    const [record_data, setRecordData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [search_key, setSearchKey] = useState('');
    const [ship_id, setBookingID] = useState('');
    const [show_modal, setShowModal] = useState(0);

    const [data_table, setDataTable] = useState([]);
    const [selected_items, setSelectedItems] = useState([]);
    const [selected_all, setSelectAll] = useState(false);
    const [datatable_state, setDataTableState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null
    });
    const [filters, setFilters] = useState({
            status: "",
            search: ""
    });


    const [selected_member_data, setMemberData] = useState('');
    const [selected_member_id, setMemberID] = useState('');
    const [selected_member_index, setMemberIndex] = useState('');
            
    const [menuAlignment, setMenuAlignment] = useState('right'); // Default desktop to right
    const actionItems = [
        {
            label: 'Export',
            icon: <FaRegFileExcel className='mr-2 text-dark'/>,
            command: () => {
                exportReport()
            }
        },
        {
            label: 'Cancel Booking',
            icon: <FaTimesCircle className='mr-2 text-danger'/>,
            command: () => {
                triggerAction(selected_items)
            },
            disabled: !helpers.checkPermissions(['superAdmin', 'shipBookingEdit'], account?.permissions),
            visible: selected_items.length ? true : false
        }
    ];

    useEffect(() => {
        initTreeView()

        const status = helpers.getURLParams('status')
        if(status){
            setFilters(prev => ({
                ...prev,
                status: status
            }));
        }

        const handleResize = () => {
        if (window.innerWidth < 768) {
            setMenuAlignment('left');  // Snaps left edge of menu to left edge of button
        } else {
            setMenuAlignment('right'); // Snaps right edge of menu to right edge of button
        }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        displayDataTable(record_data)
    }, [datatable_state.sortOrder]);

    useEffect(() => {
        displayDataTable(record_data)
    }, [
        selected_items, 
        selected_all
    ]);

    useEffect(() => {
        if(datatable_state.rows || datatable_state.page || filters.status){
            fetchDataList()
        }
    }, [
        datatable_state.rows,
        datatable_state.page,
        filters.status
    ]);

    function fetchDataList(){
        const page = datatable_state.page
        const per_page = datatable_state.rows
        const search = search_key
        let filter = `?paginate=1&`
        const status = helpers.getURLParams('status')

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }

        if(status){ 
            filter += `status=${status}&`
        }

        filter = filter.slice(0, -1)

        setLoading(1)

        const url = helpers.createShipBookingHubUrl('booking'+filter)

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setRecordData(res)
                setLoading(0)
                displayDataTable(res)
            })
            .catch((err) => {
                //console.log(err)
                setLoading(0)

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }

    function exportReport(){
        const page = datatable_state.page
        const per_page = datatable_state.rows
        const search = search_key
        let filter = `?paginate=1&export=excel&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }
        // if(transaction_type && transaction_type !== 'all'){
        //     filter += 'type='+transaction_type+'&'
        // }

        filter = filter.slice(0, -1)

        //let filter = '?store_id='+helpers.getStoreID()+'&export=excel&'

        setLoading(1)
        const today = new Date();
        const month = today.getMonth() + 1;
        const date = today.getFullYear() + '-' + month + '-' + today.getDate() + '_' +  today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds();
        const file_name = 'bookings-data-export-' + date + '.xlsx';


        //let endpoint = helpers.createUrl(`V1/cashflow/transactions/export${filter}`)
        let endpoint = helpers.createShipBookingHubUrl('booking/export'+filter)
        
        fetch(endpoint, {
            method: 'GET',
            headers: httpAuthHeaders(),
        })
        .then((res) => {
          if(res.ok) {
            return res.blob();
          }
          
          const json = res.json();
          const status_code = res.status;
  
          if (!res.ok) {
              let errorCode = json.error_code ? json.error_code : 'unknown';
              let message = json.message ? json.message : (res.statusText ? res.statusText : 'Request failed');
              let data = json.error ? json.error: '';
              let status = json.status ? json.status: '';
              let error = { data: data, message: message, error_code: errorCode, status_code: status_code, status: status };
  
              if (status_code === 422) error = { ...error, ...json };
  
              return Promise.reject(error);
          }
        })
        .then(blob => {
            toast.current.show({severity:'success', summary: 'Completed', detail: "Export successfully completed. Please check your downloads.", life: 20000});

            var url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.setAttribute("style", "display: none");
            a.setAttribute("href", url);
            a.download = file_name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.parentNode.removeChild(a);
            setLoading(0);
        })
        .catch(err => {
            //Swal.fire("Error", "Export failed", "error");
            toast.current.show({severity:'error', summary: 'Error', detail: "Export failed", life: 20000});
            setLoading(0);
            setLoading(0);
        });
    }
    
    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchDataList({
            "page": datatable_state.page + 1,
            "search": value
        })
    }

    function triggerAction(data = '', action = '', status = ''){
        let ids = [];
        if(action === 'single-cancel'){
            ids.push(data.id)
        }
        else{
            ids = data.map(o => o['id']);
        }

        let title = 'Cancel Booking'
        if(ids.length > 1){
            title = 'Cancel Bookings'
        }

        Swal.fire({
            title: title,
            text: 'This action cannot be reversed. Do you want to continue?',
            showCancelButton: true,
            showConfirmButton: false,
            closeOnCancel: true,
            showDenyButton: true,
            denyButtonText: 'Yes'
        })
        .then((result) => {
            if (result.isDenied) {
                cancelItem(ids, 4)
            }
        })
    }

    function cancelItem(id, status){
        const url = helpers.createShipBookingHubUrl('booking/status')
        httpRequest(url, 'POST', {
            postdata: {
                "ids": id,
                "status": 4
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchDataList({
                    "page": datatable_state.page + 1,
                    "per_page": datatable_state.rows,
                    "search": search_key
                })
                setSelectedItems([])

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                setSelectedItems([])

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function displayDataTable(data){
        setDataTable(
            <DataTable 
                className='border-top'
                dataKey={data.id}
                value={data.data} 
                // tableStyle={{ minWidth: '50rem' }}
                size="normal"
                paginator 
                rows={data.per_page} 
                rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data.total}
                onPage={onPage}
                first={datatable_state.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                selection={selected_items} 
                onSelectionChange={onSelectItem}
                scrollHeight="500px"
                scrollable
                responsive={true}
                emptyMessage="No data to display"
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                {/* <Column field="booking_ref" header="Booking Ref" /> */}
                <Column field="id" header="ID" />
                <Column 
                    header="Booking Ref" 
                    body={(rowData) => {
                        const { id, trip_type, parent_booking_ref, booking_ref } = rowData;
                        return trip_type ? (
                            <>
                                <Link to={`/ship-booking/bookings/${id}`}>{booking_ref}</Link>
                                {parent_booking_ref ? (<><br/><i className="fas fa-tag mr-2" />{parent_booking_ref}</>) : ''}
                            </>
                        ) : '---';
                    }}
                />
                <Column field="booking_date" header="Date" />
                <Column field="customer_name" header="Customer" />
                <Column 
                    field="trip_type" 
                    header="Trip Type" 
                    body={({trip_type}) => helpers.ucwords(trip_type)}
                />
                <Column 
                    field="departure_time" 
                    header="Departure Time" 
                    body={({departure_time})=> helpers.formatToHumanDateTime(departure_time)}
                />
                <Column 
                    field="destination" 
                    header="Route" 
                    body={(rowData) => {
                        const { origin, destination } = rowData;
                        return origin && destination ? (
                            <>
                                {origin} &rarr; {destination}
                            </>
                        ) : '---';
                    }}
                />
                <Column field="ship_name" header="Ship" />
                {/* <Column field="status_name" header="Booking Status" /> */}
                <Column 
                    header="Status" 
                    body={({status_id, status_name})=> helpers.displayBookingStatusBadge(status_id, status_name)}
                />

                
                <Column className="text-right" body={displayActionMenu} style={{ maxWidth: '100px' }}></Column> 
            </DataTable>
        )

    }

    const onPage = (e) => {
        setDataTableState(e)
        setSelectedItems([])
    };

    const onSelectItem = (e) => {
        const value = e.value;
        setSelectedItems(value);
    };

    function displayActionMenu(data){
        return (<Dropdown>
                        <Dropdown.Toggle className='btn-light border' size="sm" id={"dropdown-actions-"+data.id}>Action</Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            <Dropdown.Item 
                                key="cancel" 
                                className={helpers.checkPermissions(['superAdmin', 'shipBookingEdit'], account?.permissions) ? 'text-danger' : 'text-secondary'} 
                                onClick={(e) => triggerAction(data, 'single-cancel')}
                                disabled={!helpers.checkPermissions(['superAdmin', 'shipBookingEdit'], account?.permissions)}
                            ><i className="fas fa-times-circle mr-2" />Cancel Booking</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>)
    }
    
    function addForm(e){
        setBookingID('')
        setShowModal(1)
    }
    function editForm(id){
        setShowModal(1)
        setBookingID(id)
    }

    function handleSave(){
        fetchDataList()
    }

    return (
        <>
        <Toast ref={toast} position="top-right" />

        
        <Layout page_title={page_title} menu={menu}>

            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-0">
                                <div className="row">
                                    <div className="col-lg-3">
                                        <InputText className="w-100" placeholder="Search Booking" onChange={search} />
                                    </div>
                                    <div className="col-lg-9  d-flex align-items-center justify-content-end">
                                        <div className='d-flex justify-content-end py-2'>
                                            {/* {selected_items.length ?
                                            <Dropdown className='mr-3'>
                                                <Dropdown.Toggle className='btn-light border' id={"dropdown-actions-"}>Bulk Action</Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item 
                                                        key="cancel" 
                                                        onClick={(e) => triggerAction(selected_items)}
                                                        className={helpers.checkPermissions(['superAdmin', 'shipBookingEdit'], account?.permissions) ? 'text-danger' : 'text-secondary'} 
                                                        disabled={!helpers.checkPermissions(['superAdmin', 'shipBookingEdit'], account?.permissions)}
                                                    ><i className="fas fa-times-circle mr-2" />Cancel Booking</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown> : ''} */}
                                            
                                            
                                            <Button 
                                                className='btn btn-outline-secondary mr-3'
                                                style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                                                onClick={(event) => menuRight.current.toggle(event)} 
                                                aria-controls="popup_menu_right"
                                                aria-haspopup
                                            ><BsThreeDotsVertical /></Button> 
                                            <Menu 
                                                model={actionItems} 
                                                popup ref={menuRight} 
                                                id="popup_menu_right" 
                                                popupAlignment={menuAlignment}
                                            />

                                            {
                                                helpers.checkPermissions(['superAdmin', 'shipBookingCreate'], account?.permissions) &&
                                                (<Link className='btn btn-primary float-right' to="/ship-booking/bookings/new"><i className="fas fa-plus-circle mr-2" />New</Link>)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                { data_table }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
        </>
    )
}